export default function changeStateForm(targetId, state) {
    const listState = ['in-work', 'not-active', 'success', 'error-state']
    const target = document.querySelector(targetId);
    listState.forEach(item => target.classList.remove(item))
    target.classList.add(state)
  }